module.exports = __webpack_public_path__ + "media/images/pic/testimonials/patti-02a949464135451226ecd1848bd5df6a.jpg";